// Types definitions

import { ActionContext, ActionTree } from 'vuex'
import { SETTINGS__INIT } from '../actions'
import { UserActionTypes } from '@/store/modules/users/actions'
import { CompanyActionTypes } from '@/store/modules/companies'
import { KnowledgeAction } from '@/store/modules/knowledge/actions'
import { UserScope } from '@/models/users'

export interface SettingsState {
  updating: boolean
}

type SettingsContext = ActionContext<SettingsState, unknown>

// Settings module

function initialState(): SettingsState {
  return {
    updating: false,
  }
}

const state: SettingsState = initialState()

const actions: ActionTree<SettingsState, unknown> = {
  /**
   * Initial data loading
   *
   * @param {SettingsContext} context
   * @returns {Promise<unknown>}
   */
  async [SETTINGS__INIT](context: SettingsContext): Promise<unknown> {
    const what = []
    if (context.rootGetters.isLoggedIn) {
      await context.dispatch(UserActionTypes.GetCurrentUser)
      await context.dispatch(CompanyActionTypes.Fetch)
      if (context.getters.canDoScope(UserScope.KnowledgeView)) {
        what.push(context.dispatch(KnowledgeAction.GetBases))
      }
    }
    return Promise.all(what)
  },
}

export default {
  state,
  actions,
}
